import { initialLoggedInUserState } from "context/auth/initialLoggedInUserState";
import { UserAction } from "context/actions/UserAction";
import { UserState } from "models/UserState";

export const userReducer = (state: UserState, action: UserAction): UserState => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
          return {
              ...state,
              user: { ...action.payload},
              token: action.payload.token,
              isAuthenticated: true,
              loading: false,
          };
    case 'REFRESH_PROFILE':
          return {
              ...state,
              user: { ...action.payload},
              isAuthenticated: true,
              loading: false,
          };
      case 'LOGIN_FAILURE':
          return {
              ...state,
              isAuthenticated: false,
              user: initialLoggedInUserState,
              loading: false,
              error: action.payload,
          };
      case 'LOGOUT':
          return {
              ...state,
              isAuthenticated: false,
              user: initialLoggedInUserState,
              loading: false,
          };
      case 'SWITCH_WORKSPACE':
        return {
            ...state,
            user: {
                ...state.user,
                selectedWorkspace: {
                    ...state.user.selectedWorkspace,
                    workspaceId: action.payload,
                }
            }
        };
    default:
      return state;
  }
};
